import { isCapacitorNativeRuntime } from "./capacitor_bridge";

const API_TOKEN_STORAGE_KEY = "imonimon:api-token";
let memoryToken = "";

function storageAvailable() {
  return typeof window !== "undefined" && typeof window.localStorage !== "undefined";
}

function getPreferencesPlugin() {
  if (typeof window === "undefined") return null;

  const capacitor = window.Capacitor;
  if (!capacitor || typeof capacitor !== "object") return null;

  if (capacitor.Plugins && capacitor.Plugins.Preferences) return capacitor.Plugins.Preferences;

  if (typeof capacitor.registerPlugin === "function") {
    try {
      return capacitor.registerPlugin("Preferences");
    } catch (_error) {
      return null;
    }
  }

  return null;
}

export async function hydrateApiToken() {
  memoryToken = "";

  if (isCapacitorNativeRuntime()) {
    const Preferences = getPreferencesPlugin();
    if (Preferences && typeof Preferences.get === "function") {
      try {
        const { value } = await Preferences.get({ key: API_TOKEN_STORAGE_KEY });
        memoryToken = typeof value === "string" ? value : "";
        return memoryToken;
      } catch (_error) {
        // fall through to localStorage below
      }
    }
  }

  if (!storageAvailable()) return "";

  try {
    memoryToken = window.localStorage.getItem(API_TOKEN_STORAGE_KEY) || "";
  } catch (_error) {
    memoryToken = "";
  }

  return memoryToken;
}

export function getApiToken() {
  if (memoryToken) return memoryToken;
  if (!storageAvailable()) return "";

  try {
    return window.localStorage.getItem(API_TOKEN_STORAGE_KEY) || "";
  } catch (_error) {
    return "";
  }
}

export function setApiToken(token) {
  const normalized = String(token || "").trim();
  memoryToken = normalized;

  if (isCapacitorNativeRuntime()) {
    const Preferences = getPreferencesPlugin();
    if (Preferences && typeof Preferences.set === "function") {
      Preferences.set({ key: API_TOKEN_STORAGE_KEY, value: normalized }).catch(() => {});
    }
  }

  if (!storageAvailable()) return;

  try {
    if (normalized) {
      window.localStorage.setItem(API_TOKEN_STORAGE_KEY, normalized);
    } else {
      window.localStorage.removeItem(API_TOKEN_STORAGE_KEY);
    }
  } catch (_error) {
    // Ignore storage write failures and continue with cookie auth fallback.
  }
}

export function clearApiToken() {
  memoryToken = "";

  if (isCapacitorNativeRuntime()) {
    const Preferences = getPreferencesPlugin();
    if (Preferences && typeof Preferences.remove === "function") {
      Preferences.remove({ key: API_TOKEN_STORAGE_KEY }).catch(() => {});
    } else if (Preferences && typeof Preferences.set === "function") {
      Preferences.set({ key: API_TOKEN_STORAGE_KEY, value: "" }).catch(() => {});
    }
  }

  if (!storageAvailable()) return;
  try {
    window.localStorage.removeItem(API_TOKEN_STORAGE_KEY);
  } catch (_error) {
    // Ignore storage write failures and continue with cookie auth fallback.
  }
}

function buildAuthHeaders(headers) {
  const result = new Headers(headers || {});
  const token = getApiToken();
  if (token && !result.has("Authorization")) {
    result.set("Authorization", `Bearer ${token}`);
  }
  return result;
}

export function authFetch(input, init = {}) {
  return fetch(input, {
    credentials: "include",
    ...init,
    headers: buildAuthHeaders(init.headers)
  });
}
